import React from 'react';
import Navbar from '../components/layout/Navbar';
import EditAttendeesForm from '../components/layout/EditAttendeesForm';

function EditAttendeesPage() {
  return (
    <div>
      <Navbar />
      <div className='container'>
        <EditAttendeesForm />
      </div>
    </div>
  );
}

export default EditAttendeesPage;
